export function QuestionMarkRounded({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" {...props}>
      <g>
        <rect width="20" height="20" fill="none" />
        <path
          d="M354,1206a8,8,0,1,1-8-8A8,8,0,0,1,354,1206Z"
          transform="translate(-336 -1196)"
          fill="rgba(50,132,225,0)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
        <path
          d="M343.672,1203.6a2.4,2.4,0,0,1,4.664.8c0,1.6-2.4,2.4-2.4,2.4M346,1210h.008"
          transform="translate(-336 -1196)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
      </g>
    </svg>
  );
}
